import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {getEvents, resetEventsSearchCriteria, rememberScrollPositionListing, rememberPaginationListing} from '../../actions';
import EventsListItem from './EventsListItem';
import EventsListItemPlaceholder from './EventsListItemPlaceholder';
import LoadingSpinner from '../../../Layout/components/LoadingSpinner';
import Button from '@material-ui/core/Button';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_events_list';
import Waypoint from 'react-waypoint';
import {withLastLocation} from 'react-router-last-location';
import translationsRoutes from '../../../../app/router/translations_routes';

const NUMBER_ITEMS_PER_LINE = 4;
const NUMBER_ITEMS_PLACEHOLDER_INITIAL_LOADING = 8;

const routes = Object.values(translationsRoutes);

class EventsList extends Component {
    state = {
        initialLoad: true,
        hasCameFromOtherPage: false,
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    fetchContent() {
        const {search, loading, uiRememberPaginationListing} = this.props;

        if (!loading) {
            if (search.submitted) {
                // The search form was submitted from another page.
                // The Redux store has the search criteria in memory.
                // Fetch the events with these criteria...

                let page = 1; // No offset
                let pageWithPreviousResults = false;

                if (this.hasCameFromDetailsPage()) {
                    // Restore the pagination
                    page = uiRememberPaginationListing;
                    pageWithPreviousResults = true;
                }

                this.props.getEvents(
                    page, // No offset
                    pageWithPreviousResults, // Page with previous results
                    true, // Reset the search results / listing
                    search.public,
                    search.type,
                );
            } else {
                // Fetch the events without any search criteria
                this.props.getEvents(
                    1, // No offset
                    false, // Page with previous results
                    true, // Reset the search results / listing
                );
            }
        }
    }

    componentDidMount() {
        this.fetchContent();
    }

    componentDidUpdate(prevProps, prevState) {
        // There will never be events translated in english on this website...
        // Force the french version:
        // 1. Set the active language to 'fr' (change the entry in the Local Storage)
        // 2. Redirect to the french URL

        if (this.props.activeLanguage && this.props.activeLanguage.code !== 'fr') {
            this.props.setActiveLanguage('fr');
        }

        if (prevProps.languages !== this.props.languages) {
            const expectedUri = this.props.translate('routes.events');

            if (prevProps.activeLanguage && prevProps.activeLanguage.code === 'en') {
                window.location.replace(expectedUri);
                return false;
            }
        }

        // Restore the scroll position (if the user came from a event detail page)

        const {uiRememberScrollPositionListing, loading, events} = this.props;

        if (this.state.hasCameFromOtherPage === false && this.hasCameFromDetailsPage() && (!loading && Array.isArray(events) && events.length > 0) && uiRememberScrollPositionListing > 0) {
            this.setState({
                hasCameFromOtherPage: true,
            }, () => window.scrollTo(0, uiRememberScrollPositionListing));
        }
    }

    componentWillUnmount() {
        //this.props.resetEventsSearchCriteria();
        this.props.rememberScrollPositionListing(window.scrollY);
        this.props.rememberPaginationListing(this.props.currentPage);
    }

    hasCameFromDetailsPage = () => {
        const {lastLocation} = this.props;

        if (typeof lastLocation === 'object' && lastLocation !== null && lastLocation.hasOwnProperty('pathname') && lastLocation.pathname.length > 0) {
            if (lastLocation.pathname.startsWith(routes[0].events[0] + '/' || lastLocation.pathname.startsWith(routes[0].events[1] + '/'))) {
                return true;
            }
        }

        return false;
    };

    handleScrollLoadMore = () => {
        this.loadMore();
    };

    handleClickLoadMore = (e) => {
        e.preventDefault();

        this.loadMore();
    };

    loadMore = (e) => {
        const {loading, hasMore, currentPage, search} = this.props;

        if (hasMore && !loading) {
            this.setState({initialLoad: false});

            this.props.getEvents(
                currentPage + 1,
                false, // Page with previous results
                false, // Reset the search results / listing
                search.public,
                search.type,
            );
        }
    };

    render() {
        const {events, loading, hasMore} = this.props;

        let placeholders = [];
        let placeholders2 = [];

        if (this.state.initialLoad) {
            for (let i = 0; i < NUMBER_ITEMS_PLACEHOLDER_INITIAL_LOADING; i++) {
                placeholders.push(<EventsListItemPlaceholder key={i}/>);
            }
        } else {
            for (let i = 0; i < NUMBER_ITEMS_PER_LINE; i++) {
                placeholders2.push(<EventsListItemPlaceholder key={i}/>);
            }
        }

        return (
            <section id="events-list">
                <div className="row">
                    {(this.state.initialLoad && loading && Array.isArray(events) && events.length === 0) && placeholders}
                    {events.map(event => (
                        <EventsListItem key={event.id} event={event}/>
                    ))}
                    {(loading && !this.state.initialLoad) && placeholders2}
                    {(!loading && (Array.isArray(events) && events.length === 0)) &&
                        <div className="col col-12 text-center">
                            <p><Translate id="events_list.no_item_found" /></p>
                        </div>
                    }
                </div>
                {(hasMore && !loading) &&
                    <div className="row row-more">
                        <div className="col-lg-3 col-md-6 col-sm-12 mx-auto">
                            <div className="text-center">
                                <Waypoint onEnter={this.handleScrollLoadMore} />
                                <Button variant="contained" color="primary" size="medium" onClick={this.handleClickLoadMore}>
                                    <Translate id="events_list.button_load_more" />
                                </Button>
                            </div>
                        </div>
                    </div>
                }
                {((events === null || (Array.isArray(events) && events.length === 0) || loading) && !this.state.initialLoad) &&
                    <div className="row row-loading">
                        <div className="col-lg-3 col-md-6 col-sm-12 mx-auto">
                            <div className="text-center">
                                <LoadingSpinner/>
                            </div>
                        </div>
                    </div>
                }
            </section>
        );
    }
}

EventsList.propTypes = {
    getEvents: PropTypes.func.isRequired,
    resetEventsSearchCriteria: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    rememberScrollPositionListing: PropTypes.func.isRequired,
    rememberPaginationListing: PropTypes.func.isRequired,
    uiRememberScrollPositionListing: PropTypes.number,
    uiRememberPaginationListing: PropTypes.number,
};

const mapStateToProps = (state) => ({
    events: state.events.events,
    loading: state.events.eventsLoading,
    hasMore: state.events.hasMore,
    currentPage: state.events.currentPage,
    search: state.events.search,
    uiRememberScrollPositionListing: state.schools.uiRememberScrollPositionListing,
    uiRememberPaginationListing: state.schools.uiRememberPaginationListing,
});

export default withRouter(withLastLocation(connect(mapStateToProps, {
    getEvents,
    resetEventsSearchCriteria,
    rememberScrollPositionListing,
    rememberPaginationListing
})(withLocalize(EventsList))));



// WEBPACK FOOTER //
// ./src/features/Events/components/List/EventsList.js